import {IAppliedRule, IPredicate, RuleOperator} from '../../incase-domain/appliedRules';
import {IElement} from '../../incase-domain/elements';
import {ELEMENT} from '../../incase-domain/elements/base/ElementTypes';
import {QuestionElementInteractions, YesNoElementInteractions} from '../../incase-domain/proptypes/runfile';

export const checkIfRuleIsSatisfied = (appliedRule: IAppliedRule, presentationInteractiveElements: IElement[]): IAppliedRule => {
    const areAllPredicatesSatisfied = appliedRule.predicates.every((predicate) => {
        const interactiveElement = presentationInteractiveElements.find((runFileElement) => runFileElement.id === predicate.elementId);
        return test(predicate, interactiveElement) === (predicate.operator === RuleOperator.IF);
    });

    return {
        ...appliedRule,
        satisfied: areAllPredicatesSatisfied,
    };
};

const test = (predicate: IPredicate, interactiveElement: IElement | undefined): boolean => {
    if (!interactiveElement) return false;

    switch (predicate.elementType) {
        case ELEMENT.QUESTION:
        case ELEMENT.YES_NO_QUESTION_V2:
            return testQuestion(predicate, interactiveElement);
        case ELEMENT.YES_NO_QUESTION:
            return testYesNoQuestion(predicate, interactiveElement);
        case ELEMENT.MULTI_SELECT:
            return testQuestion(predicate, interactiveElement);
        case ELEMENT.PHOTO_ANSWER_QUESTION:
            return testQuestion(predicate, interactiveElement);
        default:
            return false;
    }
};

export const testQuestion = (predicate: IPredicate<number | string>, interactiveElement: IElement): boolean => {
    const elementInteractions = interactiveElement?.elementInteractions as QuestionElementInteractions;
    const isAnswerWithId = typeof predicate.answers[0] === 'string';
    if (!(isAnswerWithId ? elementInteractions?.clickedAnswersIds : elementInteractions?.clickedAnswers)) {
        return false;
    }
    if (isAnswerWithId) {
        return (predicate as IPredicate<string>).answers.some((a) => elementInteractions.clickedAnswersIds?.includes(a));
    }
    return (predicate as IPredicate<number>).answers.some((a) => elementInteractions.clickedAnswers?.includes(a));
};

export const testYesNoQuestion = (predicate: IPredicate, interactiveElement: IElement): boolean => {
    const elementInteractions = interactiveElement?.elementInteractions as YesNoElementInteractions;
    if (!interactiveElement || !elementInteractions || elementInteractions.answer === undefined) {
        return false;
    }
    return predicate.answers.includes(elementInteractions.answer);
};
